module.exports = __webpack_public_path__ + "static/media/8OLA9.5402e51e.jpg";